export const clientId = "businesspartner";
export const twinPersonType = "bp.contact.person";
export const twinCompanyType = "bp.contact.company";
export const twinContactInformationType = "bp.contactinformation";

export const personCompanyRelationContextId = "bp.contact.company";

export const contactDetailProperties = {
  contact: "contact",
  type: "type",
  data1: "data1",
  data2: "data2",
  data3: "data3",
  data4: "data4",
  data5: "data5",
};
